import axios from 'axios';

import History from '../../History';
import Config from '../../Config';

export const signup = payload => {
  return dispatch => {
    axios
      .post(`${Config.authLambda}/auth/signup`, payload)
      .then(response => {
        if (response && response.status === 200) {
          window.location.href = '/login';
        } else {
          alert('계정 생성에 실패하였습니다.');
        }
      })
      .catch(err => {
        console.log(err);
        alert(err.response.data.message);
      });
  };
};

export const signupJudge = payload => {
  return dispatch => {
    axios
      .post(`${Config.authLambda}/auth/signupjudge`, payload)
      .then(response => {
        if (response && response.status === 200) {
          window.location.href = '/login';
        } else {
          alert('계정 생성에 실패하였습니다.');
        }
      })
      .catch(err => {
        console.log(err);
        alert(err.response.data.message);
      });
  };
};

export const loginToHome = user => {
  return dispatch => {
    axios
      .post(`${Config.authLambda}/auth/signin`, {
        id: user.id,
        password: user.password,
      })
      .then(response => {
        let loggedInUser;

        if (response.data) {
          loggedInUser = response.data;
          localStorage.setItem('kpnp-token', JSON.stringify(loggedInUser));

          dispatch({
            type: 'LOGIN',
            payload: { loggedInUser, loggedInWith: 'kpnp-token' },
          });
          dispatch({ type: 'CHANGE_ROLE', userRole: loggedInUser.roles });
          window.location.href = '/';
        }
      })
      .catch(err => {
        console.log(err);
        alert(err.response.data.message);
      });
  };
};

export const loginReloadPage = user => {
  return dispatch => {
    axios
      .post(`${Config.authLambda}/auth/signin`, {
        id: user.id,
        password: user.password,
      })
      .then(response => {
        let loggedInUser;

        if (response.data) {
          loggedInUser = response.data;
          localStorage.setItem('kpnp-token', JSON.stringify(loggedInUser));

          dispatch({
            type: 'LOGIN',
            payload: { loggedInUser, loggedInWith: 'kpnp-token' },
          });
          dispatch({ type: 'CHANGE_ROLE', userRole: loggedInUser.roles });

          window.location.reload();
        }
      })
      .catch(err => console.log(err));
  };
};

export const logout = () => {
  return dispatch => {
    localStorage.clear();
    dispatch({ type: 'LOGOUT', payload: {} });
    window.location.href = '/';
  };
};

export const loginAgain = (loggedInUser, loggedInWith) => {
  return dispatch => {
    dispatch({
      type: 'LOGIN',
      payload: { loggedInUser, loggedInWith },
    });
    dispatch({ type: 'CHANGE_ROLE', userRole: loggedInUser.roles });
    // window.location.href="/";
  };
};

export const changeRole = roles => {
  return dispatch => dispatch({ type: 'CHANGE_ROLE', userRole: roles });
};

export const updateUserInfo = loggedInUser => {
  return dispatch => {
    localStorage.setItem('kpnp-token', JSON.stringify(loggedInUser));

    dispatch({
      type: 'LOGIN',
      payload: { loggedInUser, loggedInWith: 'kpnp-token' },
    });
    dispatch({ type: 'CHANGE_ROLE', userRole: loggedInUser.roles });

    window.location.reload();
  };
};
